import Fixed from './Fixed';

/* Types */
import { COMPONENT_POSITION } from 'types/component.types';

const Snackbar = ({ type = COMPONENT_POSITION.relative, ...otherProps }) => <Fixed />;

export default Snackbar;
